import React, { useEffect, useState } from "react";
import moment from "moment";
import thumbnail from "../../assets/video/thumbnail/firesafety.jpg";
import { Link } from "react-router-dom";
import { videoPath } from "../../server";
import defaultPhoto from "../../assets/images/simulanis_photo.jfif";

const VideoThumbnailCard = ({ data }) => {
  return (
    <>
      <div className="videocard">
        <div className="videoplbx">
          <div className="videothumb">
            <img
              className="thumbnail"
              alt=""
              src={
                data?.thumb_path && !data?.thumb_path.includes("https")
                  ? `${videoPath}${data?.thumb_path}`
                  : data?.thumb_path
              }
            />
            <Link to={`/detail-page/${data?.uuid}`} className="playbtn">
              <i className="fas fa-play"></i>
            </Link>
          </div>

          <div className="video-detail">
            <h6>{data?.title}</h6>
            <p className="d-none">{data?.description}</p>
            <p>
              <span className="viewsd">{data?.viewCount} views</span>{" "}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoThumbnailCard;
